import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '@lib/components/common/Button';

export default class RequiredProjectSaveModal extends React.Component {

    onCloseClick = () => {
        this.props.onClose()
    }

    render() {
        return (
            <Modal isOpen={this.props.visible} onClose={this.onCloseClick}>
                <Modal.Header>{__('Information')}</Modal.Header>
                <Modal.Body>
                    <p>{__('Before go to the configuration you have to save project')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.onCloseClick}>{__('Close')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}